import formsBackendClient, { ApiDefinition } from '@/tsClient/servers/noodleQuestionnaires';
import { rxGetFieldTemplatesForSectionTemplateHandler } from '@/providers/RxDB/rxdb.api';

type ThisApi =
  ApiDefinition['/questionnaire-templates/{creatorId}/{questionnaireTemplateId}/section-templates/{sectionTemplateId}/field-templates']['GET'];
type Input = ThisApi['params'];
type Config = { cache?: boolean };

const getFieldTemplatesForSectionTemplate = async (
  { creatorId, questionnaireTemplateId, sectionTemplateId }: Input,
  { cache = false }: Config = {},
): Promise<ThisApi['response']> => {
  const input = { creatorId, questionnaireTemplateId, sectionTemplateId };

  const fetchFromApi = async (): Promise<ThisApi['response']> => {
    const path = `/questionnaire-templates/${creatorId}/${questionnaireTemplateId}/section-templates/${sectionTemplateId}/field-templates`;
    const data = await formsBackendClient.get(path);
    return data.data;
  };

  if (!cache) return fetchFromApi();

  return rxGetFieldTemplatesForSectionTemplateHandler(input, fetchFromApi);
};

export default getFieldTemplatesForSectionTemplate;
